module.exports = __webpack_public_path__ + "static/media/pokesite.a7cb0fd0.png";